import { createSlice } from '@reduxjs/toolkit'
import { candidateReduxState } from '../../../reduxModels';

const initialState: candidateReduxState = {
    name: "",
    id: null,
    uuid: "",
    email: "",
    mobile: "",
    stage: "",
    is_data_processed: false,
    skills: [],
    experience: [],
    linkedin_link: "",
    position: "",
    job_title: "",
    degree: "",
    file_name: "",
    created_at: "",
    updated_at: "",
    city: "",
    source: "",
    created_by: null,
    job_id: null,
    candidate_code: "",
    job_codes: "",
    gender: "",
    diploma: "",
    university: "",
    current_company: "",
    current_position: "",
    candidate_address: "",
    skype: "",
    other_contact: "",
    current_department: "",
    candidate_industry: "",
    years_of_experience: "",
    graduation_date: "",
    current_salary: 0,
    current_benefits: "",
    notice_period: "",
    expected_salary: 0,
    candidate_location: "",
    expected_benefits: "",
    nationalities: [],
    languages: [],
    candidate_reference_name: "",
    candidate_reference_id: null,
    gdpr_consent: "",
    candidate_description: "",
    email_consent: "",
    document_type: "",
    department_name: "",
    department_id: "",
    vertical_code: "",
    vertical_id: "",
    branch_name: "",
    branch_id: "",
    company_name: "",
    company_id: "",
    document_path: "",
    assigned_to: "",
    assigned_to_user_name: "",
    stage_name: "",
    next_stage_name: "",
    offer_status: "",
    interview_documents: [],
    company_slug:""
}


const candidateDetailsSlice = createSlice({
    name: 'candidate',
    initialState,
    reducers: {
        setCandidateDetails: (state, action) => {
            return { ...state, ...action.payload };
        },
         clearCandidateDetails: () => {
            return initialState;
        },
    },
});

export const { setCandidateDetails, clearCandidateDetails } = candidateDetailsSlice.actions;

export default candidateDetailsSlice.reducer